export default __webpack_public_path__ + "static/media/bharat_event.0dc2f690.png";